import { render, staticRenderFns } from "./PrimaryHero.vue?vue&type=template&id=6dd83e87&"
import script from "./PrimaryHero.vue?vue&type=script&lang=ts&"
export * from "./PrimaryHero.vue?vue&type=script&lang=ts&"
import style0 from "./PrimaryHero.vue?vue&type=style&index=0&id=6dd83e87&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports